import { Bucket } from "@/shared/model/Bucket";
import {
  Box,
  Button,
  Dialog,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Charge } from "@/pages/sy/models/Charge";
import { chargeOperationStyles } from "@/pages/sy/styles/ChargeOperationStyles";

export const BucketModal = ({
  buckets,
  selectedBucketId,
  isBucketDialogOpen,
  handleCloseBucketDialog,
  handleBucketSelect,
  charges,
  allCharges,
  currentChargeId,
}: {
  buckets: Bucket[];
  selectedBucketId: number | null;
  isBucketDialogOpen: boolean;
  handleCloseBucketDialog: () => void;
  handleBucketSelect: (bucketId: number) => void;
  charges: Charge[];
  allCharges: Charge[];
  currentChargeId: number | null;
}) => {
  const theme = useTheme();
  const styles = chargeOperationStyles(theme);

  const currentCharge = charges.find(
    (charge) => charge.ChargeId === currentChargeId,
  );
  const isCurrentChargeScheduled = currentCharge?.ChargeStatusCode === "S";

  const getChargeUsingBucket = (bucketId: number): Charge | null => {
    // Don't show swap message if current charge is scheduled
    if (isCurrentChargeScheduled) {
      return null;
    }

    return (
      allCharges.find(
        (charge) =>
          charge.BucketId === bucketId &&
          charge.ChargeStatusCode !== "S" &&
          charge.ChargeStatusCode !== "H" &&
          charge.ChargeId !== currentChargeId,
      ) || null
    );
  };

  return (
    <Dialog
      open={isBucketDialogOpen}
      onClose={handleCloseBucketDialog}
      maxWidth="md"
      slotProps={{
        paper: {
          sx: styles.dialogPaper,
        },
      }}
    >
      <Box sx={styles.dialogHeader}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Select Bucket
        </Typography>
      </Box>

      <Box sx={styles.dialogContent}>
        <List>
          {buckets.map((bucket) => {
            const chargeUsingBucket = getChargeUsingBucket(
              bucket.BucketId as number,
            );

            return (
              <ListItem key={bucket.BucketId} disablePadding>
                <ListItemButton
                  sx={{
                    ...(styles.recipeItem as object),
                    ...(bucket.BucketId === selectedBucketId
                      ? (styles.selectedRecipeItem as object)
                      : {}),
                  }}
                  onClick={() => handleBucketSelect(bucket.BucketId as number)}
                  // disabled={!!chargeUsingBucket}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                  >
                    <Typography sx={styles.recipeText}>
                      {bucket.BucketName}
                    </Typography>
                    {chargeUsingBucket ? (
                      <Typography
                        variant="body2"
                        sx={{
                          color: "error.main",
                          fontWeight: 600,
                          fontSize: "1.2rem",
                        }}
                      >
                        Already in use
                      </Typography>
                    ) : null}
                  </Box>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>

      <Box sx={styles.dialogFooter}>
        <Button
          variant="contained"
          color="inherit"
          onClick={handleCloseBucketDialog}
          sx={styles.actionButton}
        >
          Cancel
        </Button>
      </Box>
    </Dialog>
  );
};
